import api from './api';

export interface CreateShipmentRequest {
  warehouse_name: 'NOIDA' | 'NIMIYA';
  weight?: number;
  length?: number;
  width?: number;
  height?: number;
}

export interface CreateShipmentResponse {
  success: boolean;
  message: string;
  order_id: string;
  order_number: string;
  awb_number: string;
  tracking_url: string;
  label_url: string;
  carrier: string;
}

export interface TrackShipmentResponse {
  success: boolean;
  order_id: string;
  order_number: string;
  awb_number: string;
  tracking_url: string;
  shipment_status: string;
  tracking_info: any;
}

export interface ShipmentLabelResponse {
  success: boolean;
  order_id: string;
  order_number: string;
  awb_number: string;
  label_url: string;
}

export const shipmentService = {
  /**
   * Create shipment for a sales order
   */
  createShipment: async (orderId: string, data: CreateShipmentRequest): Promise<CreateShipmentResponse> => {
    const params = new URLSearchParams();
    params.append('warehouse_name', data.warehouse_name);
    if (data.weight !== undefined) params.append('weight', data.weight.toString());
    if (data.length !== undefined) params.append('length', data.length.toString());
    if (data.width !== undefined) params.append('width', data.width.toString());
    if (data.height !== undefined) params.append('height', data.height.toString());
    
    const response = await api.post(`/admin/shipments/sales-order/${orderId}/create?${params.toString()}`);
    return response.data;
  },

  /**
   * Track shipment for a sales order
   */
  trackShipment: async (orderId: string): Promise<TrackShipmentResponse> => {
    const response = await api.get(`/admin/shipments/sales-order/${orderId}/track`);
    return response.data;
  },

  /**
   * Get shipping label URL for a sales order
   */
  getShipmentLabel: async (orderId: string): Promise<ShipmentLabelResponse> => {
    const response = await api.get(`/admin/shipments/sales-order/${orderId}/label`);
    return response.data;
  },
};
